import React, {Component} from 'react';

import { bf } from './bf';
import { ic } from './ic';
import { iv } from './iv';
import { ip } from './ip';
import { cp } from './cp';
import { cf } from './cf';
import { ce } from './ce';
import cUserDtl from './cUserDtl';

class iUserDtl extends cUserDtl {

  $id_stgs ={
    b_useCm11: true,
    b_useCm12: false,
  }

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
  }

  $id_stss = {
    s_cm1ii110: '', // ドリンク番号
  };

  $ilp_loads = () => [
    ip.$ip_load_cm1i({
      mode: 'set',
      b_clr: (global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName] == 'new') ? true : false,
//      cm10_key: global.c?.state.sgcd_pageCmns?.cm10_key,
      cm10_key: global.c?.state.sgcd_pageCmns?.cm10_key,
    }),
  ];

  $ilp_upds = () => [
    new Promise( _o_end1 => { // 利用者追加情報
      //
      let _d_vals = {
//        cm1ib11k: global.c?.state.sgcd_pageCmns?.cm10_key,
        cm1ib11k: global.c?.state.sgcd_pageCmns?.cm10_key,
        cm1ii110: global.c?.state.s_cm1ii110,
      };
      let _cnd = bf.q('[cm1ib11k]="{}"'.f(
//        global.c?.state.sgcd_pageCmns?.cm10_key
        global.c?.state.sgcd_pageCmns?.cm10_key
      ));
      cf.myCB_call_iud({
        ctr: 'ups', 
        elm: 'cm1i', 
        d_vals: _d_vals, 
        cnd: _cnd
      })
      .then(()=>{
        _o_end1();
      })
    }),
  ];

  render() {
//alert('56:{}, {}'.f(global.c?.state.sgcd_pageCmns?.userc410, global.c?.state.s_cm10cz10))
//bf.l('66:{}'.f(global.c?.state.sgcd_pageCmns))
    return (
      <ce.RootDtl
        key={-1}
        b_logo={false}
        b_alwEdit={false}
        b_rhtVsb={true}
        rhtPfx={null}
        onRhtPrs={null}
        b_entBtnVsb={true}
        n_bdyW={ic.gn_maxBdyW}
        d_hdrs={{
          pfx: iv._get_hdrPfx('スタッフ情報'),
          d_leftBtns: iv._get_leftBtns(global.c?.state.sgc_pageRole, cf.myNV_get_name(), global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName]),
          d_subMenus: {
            b_vsb: false,
          }
        }}
        d_bdys={{
          ld_defss: [
            {
              type:'Inp',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_cm10i110',
              pfx:'メール',
              b_mln:false,
            },
            {
              type:'Inp',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_cm10c310',
              pfx:'本名',
              b_mln:false,
            },
            {
              type:'Inp',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_cm10c330',
              pfx:'源氏名',
              b_mln:false,
            },
            {
              type:'Inp',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_cm11i210',
              pfx:'生年月日（YYYY-MM-DD）',
              b_mln:false,
            },
            {
              type:'Inp',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_cm11i120',
              pfx:'住所',
              b_mln:false,
            },
            {
              type:'Inp',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_cm1ii110',
              pfx:'ドリンク番号',
              b_mln:false,
            },
            {
              type:'Pck',
//              b_vsb:(ic.gb_dbg || global.c?.state.sgc_cm10_key == -1 || bf.i(global.c?.state.sgcd_pageCmns?.userc410, ['90'])) ? true : false,
              b_vsb:(bf.n(global.c?.state.sgcd_pageCmns?.user_key) == -1 || bf.i(global.c?.state.sgcd_pageCmns?.userc410, ['80', '90'])) ? true : false,
              b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit']) && global.c?.state.s_cm10i110 != 'myhouse.1801@gmail.com') ? true : false,
              state:'s_cm10c410',
              pfx:'利用者区分 ※運営者のみ表示',
/*
              ld_itemss: [
                {key:'10', pfx: 'キャスト'},
                {key:'90', pfx: '店舗運営者'},
                {key:'80', pfx: '事務担当者'},
              ],
*/
              ld_itemss: bf.b([
                {
                  b_when: global.c?.state.sgcd_pageCmns?.userc410 == '80',
                  o_then: () => [
                    {key:'10', pfx: 'キャスト'},
                    {key:'90', pfx: '店舗運営者'},
                    {key:'80', pfx: '事務担当者'},
                  ],
                },
                {
                  o_else: () => [
                    {key:'10', pfx: 'キャスト'},
                    {key:'90', pfx: '店舗運営者'},
                  ],
                },
              ]),
              b_setValOnChg:false,
            },
            {
              type:'Pck',
//              b_vsb:(bf.i(global.c?.state.sgcd_pageCmns?.userc410, ['80', '90'])) ? true : false,
//              b_vsb:(bf.i(global.c?.state.sgcd_pageCmns?.userc410, ['80', '90'])) ? true : false,
              b_vsb:(bf.i(global.c?.state.sgcd_pageCmns?.userc410, ['80'])) ? true : false,
              b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_cm10cz10',
              pfx:'表示の有無',
              ld_itemss: [
                {key:'10', pfx: '表示する'},
                {key:'0', pfx: '表示しない'},
              ],
              b_setValOnChg:false,
            },
          ],
        }}
      />
    );
  };
};

export default iUserDtl;
